import React, { useState, useEffect } from "react";
import firebase from "../data/firebase";

const Cadastro = () => {
	const [email, setEmail] = useState("");
	const [nome, setNome] = useState("");
	const [token, setToken] = useState("");
	const [usuarios, setUsuarios] = useState([]);

	useEffect(() => {
		firebase.listarUsuarios().then((resposta) => setUsuarios(resposta));
	}, []);

	return (
		<div>

	

			<form
				onSubmit={(event) => {
					event.preventDefault();
					firebase.novoUsuario(nome, email, token);
				}}
			>
				<div class="form-group">
					<label for="exampleInputEmail1">Email</label>
					<input
						type="email"
						class="form-control"
						id="exampleInputEmail1"
						aria-describedby="emailHelp"
						placeholder="Enter email"
						onChange={(event) =>
							setEmail(event.target.value.trim())
						}
					/>
				</div>
				<div class="form-group">
					<label for="exampleInputEmail1">Nome</label>
					<input
						type="text"
						class="form-control"
						id="exampleInputEmail1"
						aria-describedby="emailHelp"
						placeholder="Nome"
						onChange={(event) => setNome(event.target.value.trim())}
					/>
				</div>
				<div class="form-group">
					<label for="exampleInputEmail1">Token</label>
					<input
						type="text"
						class="form-control"
						id="exampleInputEmail1"
						aria-describedby="emailHelp"
						placeholder="Token"
						onChange={(event) =>
							setToken(event.target.value.trim())
						}
					/>
				</div>

				<button type="submit" class="btn btn-primary">
					Submit
				</button>
			</form>
			<ol>
				{usuarios.map((usuario) => (
					<li>
						<p>{usuario.nome}</p>
						<p>{usuario.email}</p>
					</li>
				))}
			</ol>
		</div>
	);
};

export default Cadastro;
